import React from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";

import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import HomeIcon from "@mui/icons-material/Home";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import PercentIcon from "@mui/icons-material/Percent";

import styles from "../LeftSideMenu/styles.css";

function LeftSideMenu({ app, config, logo }) {
  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div
      className={
        leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu is-closed"
      }
    >
      <div className="leftSideHeader">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "button-menu" : "button-menu align-left"}
        >
          {leftBarOpened ? <ArrowBackIcon /> : <ArrowForwardIcon />}
        </button>
      </div>

      <div className="leftSideContent">
        <ul>
          {!leftBarOpened && (
            <span
              style={{
                width: "40px",
                height: "2px",
                marginBottom: "9px",
                backgroundColor: "#E3E3E3",
                display: "block",
              }}
            />
          )}
          <NavItem
            muiIcon={<HomeIcon />}
            name="Página Inicial"
            path="/overview"
          />
        </ul>

        {leftBarOpened && (
          <h3 className="leftSideContentTitle"> PAY BY PERFORMANCE </h3>
        )}

        {!leftBarOpened && (
          <span
            style={{
              width: "40px",
              height: "1.5px",
              margin: "9px 16px",
              backgroundColor: "#E3E3E3",
              display: "block",
            }}
          />
        )}

        <ul>
          <NavItem
            muiIcon={<CurrencyExchangeIcon />}
            name="Sell Out Total"
            path="/sell-out-total"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<AutoGraphIcon />}
            name="Cobertura Qualificada"
            path="/qualified-coverage"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<QueryStatsIcon />}
            name="% Cobertura Formatos"
            path="/qualified-formato"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<PercentIcon />}
            name="% Sell Out DLX"
            path="/sell-out-dlx"
          />
        </ul>

        <ul>
          <NavItem
            muiIcon={<TroubleshootIcon />}
            name="Apuração PBP"
            path="/investigation"
          />
        </ul>

        {/* <ul>
          <NavItem
            muiIcon={<LightbulbOutlinedIcon />}
            name="Insights"
            path="/insights"
          />
        </ul> */}

        {leftBarOpened && <h3 className="leftSideContentTitle">AJUDA</h3>}
        {!leftBarOpened && (
          <span
            style={{
              width: "40px",
              height: "1.5px",
              margin: "0 16px",
              backgroundColor: "#E3E3E3",
              display: "block",
            }}
          />
        )}
        <ul>
          <NavItem
            muiIcon={<DescriptionOutlinedIcon />}
            name="Regras da Campanha"
            path="/"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<ContactSupportOutlinedIcon />}
            name="Perguntas Frequentes"
            path="/"
          />
        </ul>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
